import { render } from "./EtatPointVentePage.vue?vue&type=template&id=2d048972&ts=true"
import script from "./EtatPointVentePage.vue?vue&type=script&lang=ts"
export * from "./EtatPointVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__